import { registerEntityFormConfigs } from "@neu/libui";
import type { EntityFormConfig } from "@neu/libui";

import { patient_case } from "./patient_case";
import { plan_invoice } from "./plan_invoice";

const formConfigByEntity: Record<string, EntityFormConfig> = {
	patient_case,
	plan_invoice,
};

export function registerFormConfigAdapters(): void {
	registerEntityFormConfigs(formConfigByEntity);
}
